import { toast } from 'sonner';
import type { LogLevel } from '@types';
import { toastConfigByLevel } from '@lib/logger/toastConfig.tsx';

const useToastMessage = (): { showToast: (level: LogLevel, message: string) => void } => {
  const showToast = (
    level: LogLevel,
    message: string
  ): void => {
    toast[level](message, {
      duration: 5000,
      position: 'bottom-right',
      closeButton: true,
      style: toastConfigByLevel[level].style,
    });
  };

  return { showToast };
};

export default useToastMessage;